export default __webpack_public_path__ + "static/media/pay-with-boost.ff73ddbd.svg";